import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";

export function CustomerPriceListDetailFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            fieldGroupClassName: "flex flex-wrap",
            fieldGroup: [
                {
                    key: 'address',
                    className: "w-full md:w-1/2",
                    type: 'formly-address-drop-down',
                    props: {
                        label: _('common.customer'),
                        translate: true,
                        showOnlyDebitors: true,
                        attributes: {
                            // modelMode: "IdOnly",
                            'data-testid': "formly-address-drop-down-field"
                        }
                    }
                },
                {
                    key: 'customerPriceList.currency',
                    className: "w-full md:w-1/2",
                    type: 'formly-generic-enum-drop-down',
                    expressions: {
                        hide: "!model.address || model.customerPriceList?.id"
                    },
                    props: {
                        label: _('common.currency'),
                        translate: true,
                        attributes: {
                            enumName: "CurrencyCode",
                            'data-testid': "formly-generic-enum-drop-down-field"
                        }
                    }
                },
                {
                    key: 'customerPriceList.priceIncludesTax',
                    expressions: {
                        hide: "!model || !model.address || model.customerPriceList?.id"
                    },
                    className: "w-full md:w-1/2",
                    // wrappers: ["simple-title"],
                    type: 'checkbox',
                    props: {
                        label: _('price-list.priceIncludesTax'),
                        translate: true,
                        indeterminate: false,
                        attributes: {
                            'data-testid': "formly-checkbox-field"
                        }
                    }
                },

            ]
        }
    ]
}